import React, { useEffect, useState } from 'react';
import { Checkbox } from '@acko-tech/building-blocks.ui.input';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import {
  SearchPage,
  ButtonContainer,
  PopularItems,
  ItemCheckbox,
  PopularItemsContainer,
  ErrorMessage,
  ButtonText,
  BottomCTA,
  Item,
} from '../../styles';
import ItemIconElement from '../icon';

const Index = (props: any) => {
  const {
    totalValues = [],
    selectedValues = [],
    handleAdd,
    searchInput = '',
    isDesktop = false,
  } = props;
  const [updatedSelection, setUpdatedSelection] = useState(
    selectedValues || []
  );
  const [updatedItems, setUpdatedItems] = useState(totalValues);

  useEffect(() => {
    if (!!totalValues) {
      const searchTerm = searchInput?.trim();

      if (!!searchTerm) {
        const lowerCaseSearchTerm = searchTerm?.toLowerCase();

        const updatedList = totalValues?.filter(
          ({ name, code, abbr = '', cities = [] }) => {
            const lowerCaseName = name?.toLowerCase();
            const lowerCaseCode = code?.toLowerCase();
            const lowerCaseAbbr = abbr?.toLowerCase();
            const isCityMatching = cities
              ?.map((city: any) => city?.name?.toLowerCase())
              ?.some((city) => city?.startsWith(lowerCaseSearchTerm));

            return (
              lowerCaseName?.startsWith(lowerCaseSearchTerm) ||
              lowerCaseCode?.startsWith(lowerCaseSearchTerm) ||
              lowerCaseAbbr?.startsWith(lowerCaseSearchTerm) ||
              isCityMatching
            );
          }
        );
        setUpdatedItems(updatedList);
      } else setUpdatedItems(totalValues);
    }
  }, [searchInput]);

  const handleUpdate = (data: any) => {
    if (updatedSelection?.map(({ code }) => code)?.includes(data?.code)) {
      const newSelection = updatedSelection?.filter(({ code }) => {
        return code !== data?.code;
      });
      setUpdatedSelection(newSelection);
    } else setUpdatedSelection([...updatedSelection, data]);
    if (isDesktop) {
      if (updatedSelection?.map(({ code }) => code)?.includes(data?.code)) {
        const newSelection = updatedSelection?.filter(({ code }) => {
          return code !== data?.code;
        });
        handleAdd(newSelection);
      } else handleAdd([...updatedSelection, data]);
    }
  };

  return (
    <SearchPage isDesktop={isDesktop}>
      <PopularItemsContainer isDesktop={isDesktop}>
        <PopularItems>
          {updatedItems?.map((item) => (
            <ItemCheckbox
              key={item?.code}
              onClick={() => {
                handleUpdate(item);
              }}
            >
              <Item>
                <ItemIconElement item={item} />
                <div style={{ order: isDesktop ? '2' : 'unset' }}>
                  {item?.name}
                </div>
              </Item>
              <Checkbox
                className="item-checkbox"
                onChange={() => {}}
                checked={updatedSelection
                  ?.map(({ code }) => code)
                  ?.includes(item?.code)}
              />
            </ItemCheckbox>
          ))}
          {updatedItems?.length === 0 && (
            <ErrorMessage>
              {`No results found for `}
              <b>{`"${searchInput}"`}</b>
            </ErrorMessage>
          )}
        </PopularItems>
      </PopularItemsContainer>
      {!isDesktop && (
        <BottomCTA>
          <ButtonContainer>
            <PrimaryButton
              isFullWidth
              onClick={() => handleAdd(updatedSelection)}
              disabled={updatedSelection?.length < 1}
            >
              <ButtonText>{'Add'}</ButtonText>
            </PrimaryButton>
          </ButtonContainer>
        </BottomCTA>
      )}
    </SearchPage>
  );
};

export default Index;
